module.exports = __webpack_public_path__ + "img/rank-head-bg.eee798ab.png";